import {query} from 'api';
import PropType from 'prop-types';
import {lifecycle} from 'recompose';
import Recipe from './recipe/recipe';

const RecipePage = ({data}) => {
  if (!data) return null;
  return data.map(recipe => <Recipe key={recipe.id} recipe={recipe} />);
};

RecipePage.propTypes = {
  data: PropType.array,
};

export default RecipePage
  |> lifecycle({
    componentDidMount() {
      const {data, onEndReached} = this.props;
      if (data.length === 0) {
        onEndReached();
      }
    },
  })
  |> query(
    'getRecipesByCategoryAndPage',
    {loadingFullWidth: true},
    ({page, categoryId}) => `/${page}${categoryId ? `/category=${categoryId}` : ''}`,
  );
